import React, { useEffect, useState } from 'react';
import { shape } from 'prop-types';
import AUInputCheckbox from '@ancert/aui-input-checkbox';
import ArchivosAdjuntos from '../../../components/PersonasArchivos/ArchivosAdjuntos/ArchivosAdjuntos';
import PersonasImplicadas from '../../../components/PersonasArchivos/PersonasImplicadas/PersonasImplicadas';
import InfoHeader from '../../../components/InfoHeader';
import Field from '../../../components/Field/Field';
import { ROL } from '../../../lib/role.enum';

const PersonasArchivosConsulta = ({ data }) => {
  const [totalFields, setTotalFields] = useState(0);
  const [totalFieldsFilled, setTotalFieldsFilled] = useState(0);
  const [isError, setIsError] = useState(false);
  const [involved, setInvolved] = useState([]);
  const [denunciante, setDenunciante] = useState('');

  const getFormData = () => {
    try {
      const dataObj = JSON.parse(data?.data);
      let countFields = 0;
      let countFieldsFilled = 0;
      dataObj.forEach((row) => {
        countFields += row.length;
        countFieldsFilled += row.filter((col) => col.value).length;
      });
      setTotalFields(countFields);
      setTotalFieldsFilled(countFieldsFilled);
      setInvolved(JSON.parse(data.involved));
      const denuncianteData = data?.users.find(({ role }) => role?.name === ROL.DENUNCIANTE);
      if (denuncianteData) {
        setDenunciante(denuncianteData?.user?.document);
      }
    } catch (e) {
      console.error(e);
      setIsError(true);
    }
  };

  useEffect(() => {
    getFormData();
  }, [data]);

  const headerInfo = [
    {
      icon: 'audio',
      description: `Audios: ${data.attachments.some(({ name }) => name.includes('.mp3')) ? 1 : 0}`,
    },
    { icon: 'chatOutline', description: `Formulario: ${totalFieldsFilled}/${totalFields}` },
    { icon: 'userOutline', description: `Denunciante: ${denunciante || 'Anónimo'}` },
    { icon: 'attach', description: `Archivos adjuntos: ${data.attachments.length}` },
    { icon: 'docUsers', description: `Personas implicadas: ${involved.length}` },
  ];

  return (
    <div className="c-sii-personas-archivos">
      <h2 className="u-mt-32">Personas relacionadas y Archivos adjuntos</h2>
      {isError || !data ? (
        <p className="u-mt-16">No hay datos</p>
      ) : (
        <>
          <InfoHeader items={headerInfo} />
          <ArchivosAdjuntos archivos={data.attachments} viewMode />
          <PersonasImplicadas personas={involved} viewMode />
          <div className="o-sii-checkbox-container u-mt-32">
            <AUInputCheckbox label="¿Quiero solicitar una reunión." checked={!!data?.meeting} readOnly />
            {data?.meeting && (
              <Field className="c-sii-field--no-feedback u-mt-16" condensed label="¿Con quién le gustaría reunirse?">
                {data?.meeting}
              </Field>
            )}
          </div>
        </>
      )}
    </div>
  );
};
PersonasArchivosConsulta.propTypes = {
  data: shape({}),
};
PersonasArchivosConsulta.defaultProps = {
  data: null,
};

export default PersonasArchivosConsulta;
